import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { I18nConfig, provideConfig } from '@spartacus/core'
import { orderTranslationChunksConfig, orderTranslationsEn } from '@spartacus/order/assets'
import { OrderComponentsModule } from '@spartacus/order/components'
import { OrderCoreModule } from '@spartacus/order/core'
import { OrderOccModule } from '@spartacus/order/occ'
import { OrderRootModule } from '@spartacus/order/root'
import { CustomOrderModule } from '../../../features/order/custom-order.module'

@NgModule({
  declarations: [],
  imports: [CommonModule, OrderRootModule, OrderCoreModule, OrderOccModule, OrderComponentsModule, CustomOrderModule],
  providers: [
    provideConfig(<I18nConfig>{
      i18n: {
        resources: { en: orderTranslationsEn },
        chunks: orderTranslationChunksConfig
      }
    })
  ]
})
export class OrderFeatureModule {}
